import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="px-6 md:px-10 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="mb-14">
            <p className="text-xs font-medium text-foreground-500 uppercase tracking-widest mb-3">
              Shop by Category
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-primary-800 leading-tight">
              Curated Product
              <br />
              <span className="italic font-normal text-primary-600">Categories For You</span>
            </h2>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {categories.map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group block rounded-3xl overflow-hidden bg-background-50 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
                style={{ boxShadow: '0 4px 20px rgba(0,0,0,0.04)' }}
              >
                <div className="aspect-[4/5] overflow-hidden">
                  <img
                    src={cat.imageUrl}
                    alt={`Superbuy Spreadsheet ${cat.name} category - browse products and deals`}
                    title={`Superbuy Spreadsheet ${cat.name} Products`}
                    className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1">
                    Explore products
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}